import React from 'react';
import Cookies from 'js-cookie';
import _ from 'lodash';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar';
import '../css/Movies.css';
import Loader from 'react-loader-spinner'
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
;

// component used in ai section for viewing ai data

 class Movies extends React.Component{
  state={
    logData: [],
    sortedType: '',
    searchValue: '', 
    actualData: [],
    searchActive: false,
    loadSpinner: true
    
  }
  componentDidMount(){
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }
  // new edit 
      fetch('/cloud/aimoviesdata' ,{
        method: "GET",
        headers: headers,
    })
             .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
    .then(data => {
      console.log(data)
      this.setState({
        logData: data,
        actualData: data
      },()=>{
        this.setState({
          loadSpinner: false
        })
      })
    })
    .catch((err)=>{
      console.log(err)
    })
      }



      restoreData = (data) => {
        this.setState({
          logData: data
        })
      }
       sortingFunc = (type,searchValue) => {
         if(this.state.sortedType!==type && type!=='search' ){
           this.setState({
             sortedType: type
           })
         Sorting(this.restoreData, type, this.state.logData);
         }else if(type==='search'){
           type='search';
           Sorting(this.restoreData, type, this.state.actualData,searchValue);
         }else{
           type='reverse';
         Sorting(this.restoreData, type, this.state.logData);
         }
       }
         
    
    render(){
        return (
          <div className="movies">
           { this.props.redux.auth.searchBarShow ?  <div className='animated animated-duration-custom slideInDown pb-3 mx-4'>
                        <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  /></div> : null}
           <h3 className="ai-heading dashboard-ai-heading ml-5">AI Movies User Data</h3>
          {!this.state.loadSpinner ?   <div className="si-list">
          <div className="outer">
            <div className="flex">            
                <table className="table table-striped table-fixed" >
                  <thead className="tableHeaderColor">                    
                      <th scope="col">S. No.  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('ID')}}></i></th>
                      <th scope="col">Room ID  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('roomId')}}></i></th>
                      <th scope="col">User ID  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('userId')}}></i></th>
                      <th scope="col">Genre  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('genre')}}></i></th>
                      <th scope="col">Movies  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('movie')}}></i></th>
                      <th scope="col">In Time  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('in_time')}}></i></th>
                      <th scope="col">Out Time  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('out_time')}}></i></th>
                      <th scope="col">Duration  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('duration')}}></i></th>
                      <th scope="col">IMDB  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('imdbRating')}}></i></th>
                      <th scope="col">Rating  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('rating')}}></i></th>
                      <th scope="col">Language  <i class="fas fa-sort pointer"  onClick={(e)=>{this.sortingFunc('language')}}></i></th>                   
                  </thead>
                  <tbody>        
                  {this.state.searchActive ? <tr>
                      <td colSpan={7}>
                      <div className="col-12">
                      <IntegrationReactSelectNew  autoFocus
                                    value={this.state.searchValue}
                                    onChange={(e)=>{                  
                                      this.setState({
                                        searchValue: e
                                      },()=>{
                                        this.sortingFunc('search',this.state.searchValue)
                                      })
                                    }
                                  }  
                                  onRequestSearch={() => this.sortingFunc('search',this.state.searchValue)}
                                  />
                     </div>
                      </td>
                    </tr> : null}            
                  {this.state.logData.map((e,index)=>{
                    return (
                      <tr key={index}  className="some-hover">
                          <th scope="row">{e.ID}</th>
                          <td>{e.roomId}</td>
                          <td>{e.userId}</td>
                          <td>{e.genre}</td>
                          <td>{e.movie}</td>
                          <td>{e.in_time}</td>
                          <td>{e.out_time}</td>
                          <td>{e.duration}</td>
                          <td>{e.imdbRating}</td>
                          <td>{e.rating}</td>
                          <td>{e.language}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                    </div>
                  </div>
          </div> :  <div className="spinnerLoad" style={{'marginTop': '12%', 'marginLeft': '45%'}}>
          <Loader 
	     type="Bars"
	     color="#f89500"
	     height="75"	
	     width="75"
	  />    
          </div>}
          </div>
        );
    }
}

const mapStateToProps = state  => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps) (Movies);